<template>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="$emit('closePopup')">
              <v-icon>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>Payouts ({{ payDate }})</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <PayoutsTable :selectedItem="selectedItem"/>
            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>
    </v-layout>
  </template>

<script>
import PayoutsTable from '../PayoutsTable.vue';
import moment from 'moment';
export default {
  components: {
    PayoutsTable
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    payDate() {
      return moment(this.selectedItem.pay_date).format('MM/DD/YYYY');
    }
  },
  data () {
    return {
    }
  }
}
</script>